module.exports = __webpack_public_path__ + "img/slider_10.2550542e.jpg";